import { render, staticRenderFns } from "./NodePairing.vue?vue&type=template&id=132d51cc"
import script from "./NodePairing.vue?vue&type=script&lang=js"
export * from "./NodePairing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports